// Testimonials Carousel
$(document).ready(function () {
  if ($(".testimonials-section").length) {
    const $testimonialsCarousel = $(".carousel-contain.owl-carousel");
    $testimonialsCarousel.owlCarousel({
      autoplay: true,
      autoplayTimeout: 6500,
      loop: true,
      items: 1,
      singleItem: true,
      nav: true,
      dots: true,
      stagePadding: 0,
      navText: [
        '<svg viewBox="0 0 27 52" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.28516L26 26.2852L1 51.2852" stroke="#111111"/></svg>',
        '<svg viewBox="0 0 27 52" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.28516L26 26.2852L1 51.2852" stroke="#111111"/></svg>',
      ],
      responsive: {
        1: { stagePadding: 0 },
        950: { stagePadding: 100 },
        1200: { stagePadding: 250 },
        1920: { stagePadding: 350 },
        2500: { stagePadding: 500 },
      },
    });

    $testimonialsCarousel.on("changed.owl.carousel", function (event) {
      $testimonialsCarousel.trigger("stop.owl.autoplay"); // resets the autoplay when
      $testimonialsCarousel.trigger("play.owl.autoplay"); // user performs any actions
    });
  }
});
